import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'components/tooltip';
import Details from './details';
import { columnConfig } from '../config';

import './styles.scss';

export default function ShadowDocumentUsage({ shadow }) {
  const { documentUsage } = shadow;
  if (!documentUsage || !documentUsage.length) {
    return null;
  }

  const copy = columnConfig['usedIn'].getText(shadow);

  return (
    <Tooltip
      content={<Details shadow={shadow} />}
      overlayClassName="shadow-document-usage-tooltip"
      placement="bottom"
    >
      <a>{copy}</a>
    </Tooltip>
  );
}

ShadowDocumentUsage.propTypes = {
  shadow: PropTypes.shape({
    documentUsage: PropTypes.arrayOf(PropTypes.shape({
      document: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    })),
  }).isRequired,
};
